<slider
  [pagination]="false"
  [navigation]="true"
  [breakpoints]="{
    '0': { slidesPerView: 1, spaceBetween: 8 },
    '640': { slidesPerView: 2, spaceBetween: 12 },
    '1024': { slidesPerView: 3, spaceBetween: 16 }
  }">
  @for (user of users(); track user.uid) {
    <ng-template appSlideItem>
      <kpis-score-card
        [appClicks]="'home - agencia - ' + user.name"
        [user]="user"
        [link]="['/team', user.escuderia, user.agencia]">
      </kpis-score-card>
    </ng-template>
  }
</slider>
